module.exports = __webpack_public_path__ + "img/SER-B-1-V.e30ad568.png";